import MetaBuying from "./MetaBuying";

export default MetaBuying;
